// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-a3677f96],.error[data-v-a3677f96]{display:flex;flex-direction:column}.error[data-v-a3677f96]{align-items:center;justify-content:center;margin:auto;padding:64px 0}.error__title[data-v-a3677f96]{margin-bottom:24px;text-align:center}.error .button[data-v-a3677f96]{font-size:13px;font-style:normal;font-weight:400;line-height:100%;padding:11px 24px}.error .button a[data-v-a3677f96]{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
